<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";


const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { headlineText, headlineType, toplineText, toplineType, Boxes } = props.content.data

</script>
<template>
  <section class="relative">
    <div class="mb-10">
      <div class="container px-0 xl:px-5">
        <SharedTopline :headline="toplineText" :headlineType="toplineType"></SharedTopline>
        <SharedHeadline :headline="headlineText" :headlineType="headlineType"></SharedHeadline>
      </div>
    </div>
    <div class="prose-h3:mb-7 prose-p:text-sm prose-ul:list-disc prose-ul:pl-4 prose-ul:text-sm">
      <div class="container max-w-[90rem] desktop:px-10 px-0 xl:px-5">
        <div v-if="Boxes[0]" class="relative mb-11">
          <div class="lg:w-[35rem] desktop:w-[35rem] lg:ml-[3rem] laptop:ml-[10rem] relative">
            <span class="hidden lg:block w-4 h-4 rounded-full bg-skin-theme absolute top-1 -left-10"></span>
            <h3 v-html="Boxes[0].boxTitle"></h3>
            <div v-html="Boxes[0].boxText"></div>

            <img src="/images/arc1.svg" alt="" class="hidden lg:block absolute desktop:top-6 desktop:-left-14 w-[14rem] h-[6rem] desktop:w-auto desktop:h-auto -left-[5rem] top-[3rem] rotate-[10deg] desktop:rotate-0">
          </div>
        </div>
        <div v-if="Boxes[1]" class="relative mb-11">
          <div class="lg:w-[35rem] desktop:w-[35rem] lg:ml-[23%] laptop:ml-[30%] relative">
            <span class="hidden lg:block w-4 h-4 rounded-full bg-skin-theme absolute top-1 -left-10"></span>
            <h3 v-html="Boxes[1].boxTitle"></h3>
            <div v-html="Boxes[1].boxText"></div>

            <img src="/images/arc2.svg" alt="" class="hidden lg:block absolute desktop:top-6 desktop:-left-[8.5rem]
                                w-[25rem] h-[25rem] desktop:w-auto desktop:h-auto -left-[10rem] top-[2.5rem]">
          </div>
        </div>
        <div v-if="Boxes[2]" class="relative">
          <div class="ml-[0%]  w-[100%] lg:ml-[45%] lg:w-[32rem] xl:ml-[55%] xl:w-[35rem] desktop:w-[35rem] relative">
            <span class="hidden lg:block w-4 h-4 rounded-full bg-skin-theme absolute top-1 -left-10"></span>
            <h3 v-html="Boxes[2].boxTitle"></h3>
            <div v-html="Boxes[2].boxText"></div>
          </div>
        </div>
      </div>
    </div>

    <img
      src="/images/layer2.svg"
      alt=""
      class="absolute left-[15%] -translate-x-1/2 top-[60%] hidden lg:block pointer-events-none rotate-45"
    />

    <img
      src="/images/layer2.svg"
      alt=""
      class="absolute right-[15%] top-0 hidden lg:block pointer-events-none rotate-180"
    />
  </section>
</template>
